import { Link } from "react-router-dom";
import { Page } from "@/components/PublicLayout";
import { JourneyPath } from "@/components/JourneyPath";
import { ImportantNote } from "@/components/ImportantNote";
import { BranchDivider } from "@/components/Brand";
import { useBlocks, journeyStations } from "@/hooks/useContent";
import { useAuth } from "@/context/AuthContext";
import { t } from "@/lib/i18n";

export default function HowItWorksPage() {
  const { data: blocks } = useBlocks();
  const { user } = useAuth();
  return (
    <Page title="How It Works" lede="Your Care Journey has five stations. Each one unlocks the next, and you move at your own pace." testId="how-it-works-page">
      <BranchDivider className="mb-12 max-w-3xl" />
      <div className="grid gap-14 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <JourneyPath stations={journeyStations(blocks)} />
          <BranchDivider className="mt-12" />
          <div className="mt-10 flex flex-col gap-3 sm:flex-row">
            <Link to={user ? "/portal" : "/sign-up"} className="btn-primary" data-testid="how-get-care-button">{t("nav.getCare")}</Link>
            <Link to="/who-can-receive-care" className="btn-secondary" data-testid="how-who-link">{t("nav.who")}</Link>
          </div>
        </div>
        <div className="lg:col-span-5">
          <ImportantNote />
        </div>
      </div>
    </Page>
  );
}
